export default __webpack_public_path__ + "static/media/logo_erip.98a18fd6.png";